import { useState } from "react";
import { Modal, Show } from "shared/components";
import { Applicant } from "types/application";
import { CombinedIncome } from "../../types/income";
import { SelectVerificationFlow } from "./SelectVerificationFlow";
import { ReverifyFlows } from "./types";
import { ReverifyWithDocumentsFlow } from "./ReverifyWithDocumentsFlow";
import { SendRequestFlow } from "./SendRequestFlow";
import { VerificationSettings } from "types/landlord/reports";

interface Props {
  opened: boolean;
  onClose: () => void;
  applicant: Applicant;
  applicationId: number | string;
  verificationId: number | string;
  income?: CombinedIncome;
  onSuccess: () => void;
  settings?: VerificationSettings;
  initialFlow?: ReverifyFlows;
}

export const ReverifyIncomeModal = ({
  opened,
  onClose,
  applicant,
  applicationId,
  verificationId,
  income,
  onSuccess,
  settings,
  initialFlow
}: Props) => {
  const [currentFlow, setCurrentFlow] = useState<ReverifyFlows>(
    initialFlow ?? ReverifyFlows.SelectOption
  );
  const [selectedReverifyOption, setSelectedReverifyOption] = useState<
    ReverifyFlows.ReVerifyHere | ReverifyFlows.SendRequest
  >(ReverifyFlows.ReVerifyHere);

  if (!income) return null;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="max-w-[488px] w-full h-[640px] flex flex-col"
    >
      <Show if={currentFlow === ReverifyFlows.SelectOption}>
        <SelectVerificationFlow
          onClose={onClose}
          setCurrentFlow={setCurrentFlow}
          selectedReverifyOption={selectedReverifyOption}
          setSelectedReverifyOption={setSelectedReverifyOption}
        />
      </Show>

      <Show if={currentFlow === ReverifyFlows.ReVerifyHere}>
        <ReverifyWithDocumentsFlow
          opened={opened}
          onClose={onClose}
          applicant={applicant}
          applicationId={applicationId}
          verificationId={verificationId}
          incomeId={income.id}
          income={income}
          onSuccess={onSuccess}
        />
      </Show>
      <Show if={currentFlow === ReverifyFlows.SendRequest}>
        <SendRequestFlow
          opened={opened}
          onClose={onClose}
          applicant={applicant}
          applicationId={applicationId}
          verificationId={verificationId}
          income={income}
          onSuccess={onSuccess}
          settings={settings}
        />
      </Show>
    </Modal>
  );
};
